import { EyeIcon } from '@heroicons/react/24/solid'
import { Input, Select, Toggle } from '@/components/ui'
import { typeMandatOptions } from './options'

export default ({ control, mandat, validator = {}, readOnlyType = false }) => {

  const handleDownload = (file) => {
    window.open(mandat[file].url, '_blank')
  }

  return (
    <>
      <Select.Form
        control={control}
        name="type_mandat"
        label="Type de mandat"
        options={typeMandatOptions}
        disabled={readOnlyType}
      />
      
      <Input.Text
        control={control}
        name="numero"
        label="Numéro du mandat"
        validator={validator}
      />
      
      <Input.Date
        control={control}
        name="date_signature"
        label="Date de signature"
        validator={validator}
      />

      <div className="flex justify-between items-start pr-6">
        <Input.File control={control}
          name="mandat_file"
          label="Mandat signé"
          defaultValue={mandat?.mandat_file ? "Modifier le fichier" : ""}
          inputProps={{accept: [".pdf"]}}
          className="max-w-[350px]"
          canDelete={true}
        />
        { mandat?.mandat_file && (
          <button 
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              handleDownload("mandat_file")
            }}
            className="btn btn-sm btn-ghost btn-square p-1 hover:bg-primary-400"
            title={`Voir le mandat signé`} aria-label={`Voir le mandat signé`}
          >
            <EyeIcon/>
          </button>
        )}
      </div>
    </>
  )
}
